export default "__VITE_ASSET__DPcAy7pt__"